const resources = {
    getStarted: 'Get Started',
    signInToGetStarted: 'Sign In to Get Started'
};

export default function getResource(label) {
    return resources[label];
}
